import React, { useMemo } from 'react'
import { m } from 'framer-motion'
import { useTheme } from '../../../context/ThemeContext'
import { MenuDetailContent } from '../../../types/content.types'

interface MenuDetailSectionProps {
    content: MenuDetailContent
}

const MenuDetailSection: React.FC<MenuDetailSectionProps> = ({ content }) => {
    const { theme } = useTheme()

    const categories = useMemo(() => [
        { id: 'lunch', title: content.categories.lunch, items: content.items.lunch },
        { id: 'set', title: content.categories.set, items: content.items.set },
        { id: 'main', title: content.categories.main, items: content.items.main },
        { id: 'other', title: content.categories.other, items: content.items.other },
    ], [content])

    return (
        <section id="menu-detail" className={`restaurant-menu-detail theme-${theme.mode}`}>
            <div className="restaurant-menu-detail-container">
                <m.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                    className="restaurant-menu-detail-header"
                >
                    <span className="restaurant-menu-detail-label">{content.detailLabel}</span>
                    <div className="h-px w-12 bg-gray-600 mx-auto mt-4 mb-6" />
                    <h2 className="restaurant-menu-detail-title">{content.detailTitle}</h2>
                </m.div>

                <div className="restaurant-menu-detail-categories">
                    {categories.map((category, categoryIndex) => (
                        <m.div
                            key={category.id}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: categoryIndex * 0.1 }}
                            className="restaurant-menu-detail-category"
                        >
                            <h3 className="restaurant-menu-detail-category-title">{category.title}</h3>
                            <div className="restaurant-menu-detail-items">
                                {category.items.map((item, itemIndex) => (
                                    <m.div
                                        key={itemIndex}
                                        initial={{ opacity: 0, x: -20 }}
                                        whileInView={{ opacity: 1, x: 0 }}
                                        viewport={{ once: true }}
                                        transition={{ duration: 0.5, delay: itemIndex * 0.05 }}
                                        className="restaurant-menu-detail-item"
                                    >
                                        <div className="restaurant-menu-detail-item-content">
                                            <div className="restaurant-menu-detail-item-header">
                                                <h4 className="restaurant-menu-detail-item-name">
                                                    {item.name}
                                                    {item.isRepresentative && (
                                                        <span className="restaurant-menu-detail-badge">{content.badge}</span>
                                                    )}
                                                </h4>
                                                <span className="restaurant-menu-detail-item-price">{item.price}</span>
                                            </div>
                                            {item.description && (
                                                <p className="restaurant-menu-detail-item-description">
                                                    {item.description}
                                                </p>
                                            )}
                                        </div>
                                    </m.div>
                                ))}
                            </div>
                        </m.div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default MenuDetailSection

